(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventStatusDialogController', EventStatusDialogController);

    EventStatusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'EventStatus', 'EventType'];

    function EventStatusDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, EventStatus, EventType) {
        var vm = this;
        vm.eventStatus = entity;
        vm.eventtypes = EventType.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:eventStatusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.eventStatus.id !== null) {
                EventStatus.update(vm.eventStatus, onSaveSuccess, onSaveError);
            } else {
                EventStatus.save(vm.eventStatus, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
